import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { step1Schema, uiSchema } from './Schema';
import './SourceMappingEditor.scss';

export default class SourceMappingEditor extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { formData: {} };
  }

  componentDidMount() {
    this.setState({ formData: this.props.sourceMapping });
  }

  onSubmit = ({ formData }) => {
    const sourceMapping = {
      ...this.state.formData,
      ...formData,
    };
    this.props.onSave(sourceMapping);
  };

  render() {
    const { fetching } = this.props;
    return (
      <div className="sourceMapping-edit-container">
        <Form
          schema={step1Schema}
          uiSchema={uiSchema}
          formData={this.state.formData}
          onSubmit={this.onSubmit}
          enctype="multipart/form-data"
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching}
            type="submit"
          >
            Save
          </Button>
        </Form>
      </div>
    );
  }
}

SourceMappingEditor.propTypes = {
  fetching: PropTypes.bool,
  sourceMapping: PropTypes.object,
  onSave: PropTypes.func,
};
